module.exports = __webpack_public_path__ + "media/npc_dota_hero_alchemist.3decd0b4.webm";